<template>
  <div>

    <div v-if="parc.dateLastPublication && !isDepublie" class="mt-1 mb-4 fs-6 fw-light">
      Parc publié sur GéoRisques le {{ $filters.formatDate(parc.dateLastPublication) }}
    </div>
    <StatusSection/>
    <CharacteristicsSection/>
    <ExploitantSection/>
  </div>
</template>

<script>
import StatusSection from "@/components/ParcCard/StatusSection.vue";
import CharacteristicsSection from "@/components/ParcCard/CharacteristicsSection.vue";
import {mapGetters} from "vuex";
import ExploitantSection from "@/components/ParcCard/ExploitantSection.vue";

export default {
  name: 'ParcInfo',
  computed: {
    ...mapGetters({
      parc: "parc",
      isPublie: "isPublie",
      isDepublie: "isDepublie",
      eoliennesConstructeurs: "eoliennesConstructeurs",
      eoliennesMaxHauteur: "eoliennesMaxHauteur"
    })
  },
  components: {
    StatusSection,
    CharacteristicsSection,
    ExploitantSection
  },
}
</script>
